import {client} from './services/client'

export  const categories = {
    namespaced:true,
    state:{
        categories:[],
        categorieloading:true,
    },
    mutations: {
        SET_CATEGORIE (state,categories){
            state.categories = categories
        },
        SET_CATEGORIELOADING (state,categories){
            state.categorieloading = categories
        },


    },
    actions: {
        getCategories({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/categories/get',
                })
                    .then((response)=>{
                        let categories = response.data.categories;
                        console.log(categories);
                        commit('SET_CATEGORIE',categories)
                        commit('SET_CATEGORIELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setUpdateCategorie({commit},data){
            commit('SET_CATEGORIELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/categories/update',
                    data:data,
                })
                    .then((response)=>{
                        let categories = response.data.categories;
                        commit('SET_CATEGORIE',categories);
                        commit('SET_CATEGORIELOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setCategorie({commit},data){
            commit('SET_CATEGORIELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/categories/save',
                    data:data,
                })
                    .then((response)=>{
                        let categories = response.data.categories;
                        commit('SET_CATEGORIE',categories);
                        commit('SET_CATEGORIELOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteCategorie({commit},id){
            commit('SET_CATEGORIELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/categories/delete/'+id,
                })
                    .then((response)=>{
                        let categories = response.data.categories;
                        commit('SET_CATEGORIE',categories);
                        commit('SET_CATEGORIELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getCategories: state  => {
            return state.categories
        },
    }
};
